module.exports = __webpack_public_path__ + "img/horizontal_3_6_8017.0aa223e1.png";